import { ItemSelectionKind } from "client/Hooks";
import { MouseEvent } from "react";

export const headerHeight = 48;
export const rowHeight = 48;
export const bufferSize = 5;

export function getSelectionKindFromClickEvent(event: MouseEvent): ItemSelectionKind {
	return (
		event.ctrlKey ? ItemSelectionKind.Append :
		event.shiftKey ? ItemSelectionKind.RangeFromPrevious :
		ItemSelectionKind.Override
	);
}